import { Button, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Cancel } from '@mui/icons-material';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Boot from './Boot';
import RootLayout from './Screens/RootLayout';
import Theme from './Theme';
import './App.scss';

const CloseButton = ({ closeToast }: { closeToast: any }) => (
  <Button
    variant="outlined"
    aria-label="Dismiss"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      closeToast(e);
    }}
  >
    <Cancel />&nbsp;Cancel
  </Button>
);

export { CloseButton };

const App: React.FC = () => {
  Boot().then(() => { /* no-op */ });
  return (
    <BrowserRouter>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <RootLayout />
        <ToastContainer closeButton={CloseButton} />
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
